$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");

    const subDiscount = $(this).data('selling-plan-discount');
    if (subDiscount) $('.pp_var_autoship_title span').text(subDiscount)

    var indexOpt = $(this).attr("data-index");
    $(".product_atc-refills").addClass("hided");
    $('.product_atc-refills[data="' + indexOpt + '"]').removeClass("hided");

    $('.cta-note.changeble').addClass('hided');
    $('.cta-note.changeble[data-id="'+indexOpt+'"]').removeClass('hided');
  });

  $(".pp_var_autoship").click(function () {
    $(this).toggleClass("disabled");
    if ($(".pp_var_autoship").hasClass("disabled")) {
      $(".product_atc-footer-line").addClass("hided");
      $('.product-selector_outer[data="sub"]').removeClass("active_block");
      $('.product-selector_outer[data="otp"]').addClass("active_block");
      $('.under_cta_new').addClass('hided');
    } else {
      $('.product-selector_outer[data="sub"]').addClass("active_block");
      $('.product-selector_outer[data="otp"]').removeClass("active_block");
      $(".product_atc-footer-line").removeClass("hided");
      $('.under_cta_new').removeClass('hided');
    }
  });

  $(".product-selector_atc").click(function () {
    var mode = $(".product-selector_outer.active_block").attr("data");
    var items = [];
    var currentId  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-id');
    var currentQty  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-qty');
    var sellingPlan  = $(".product-selector_outer.active_block").find('.product-selector_block.active').attr('data-selling-plan');
     if (mode == "sub") {
        items.push({
            id: currentId,
            quantity: currentQty,
            selling_plan: sellingPlan
        });
     }
     else{
        items.push({
            id: currentId,
            quantity: currentQty
        });
     }

     $(".product-selector_outer.active_block").find('.product-selector_block.active').find('.pp_selector-gift-real').each(function(){
        var currId = $(this).attr('data-id');
        var isSub = $(this).attr('data-sub');
        var currSellId = $(this).attr('data-selling-plan');
        if (isSub == 'true'){
           items.push({
              id: currId,
              quantity: 1,
              selling_plan: currSellId
          });
        }
        else{
           items.push({
              id: currId,
              quantity: 1
          });
        }
       
     });

     console.log(items, 'ITEMS');

     $.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
            $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: { items: items },
            dataType: "json",
            success: function () {
                window.location.href = '/checkout';
            },
            error: function () {
                alert("Error adding item to the cart.");
            }
            });

        },
        error: function () {
            
        }
    });
     
  });

  // $(".product-selector_atc").click(function () {
  //   if ($(this).attr("data-mode-champs") == "true") {
  //     var newUrl = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-champs-url");

  //     window.location.href = newUrl;
  //   } else {

  //     var items = [];

  //     var currentId = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-id");
  //     var mode = $(".product-selector_outer.active_block").attr("data");
  //     var currentSellingPlan = $(".product-selector_outer.active_block")
  //       .find(".product-selector_block.active")
  //       .attr("data-selling-plan");
  //     if (mode == "sub") {

  //       data = {
  //         id: currentId,
  //         quantity: 1,
  //         selling_plan: currentSellingPlan,
  //       };

  //       items.push({ id: currentId, quantity: 1, selling_plan: currentSellingPlan });
  //     } else {

  //       data = {
  //         id: currentId,
  //         quantity: 1,
  //       };

  //       items.push({ id: currentId, quantity: 1 });
  //     }

  //     var giftMode = $('.product-selector_atc').attr('data-gifts');
  //     if (giftMode == 'true'){
  //       $('.product-selector_block[data-id="'+currentId+'"]').find('.variant_gift-data').each(function(){
  //         var currentGiftId = $(this).attr('data-id');
  //         var currentGiftQty = 1;

  //         items.push({ id: currentGiftId, quantity: currentGiftQty });
  //       });
  //     }

  //     jQuery.ajax({
  //       type: "POST",
  //       url: "/cart/add.js",
  //       data: {
  //         items: items,
  //       },
  //       dataType: "json",
  //       success: function () {},
  //       error: function () {
  //         alert("Error adding item to the cart.");
  //       },
  //     });
  //   }
  // });


  const coc_urlParams = new URLSearchParams(window.location.search);
  const coc_utms = {};

  coc_urlParams.forEach(function (coc_value, coc_key) {
    const k = coc_key.toLowerCase();
    if (k === 'utm' || k.startsWith('utm_')) {
      coc_utms[coc_key] = coc_value;
    }
  });

  if (!Object.keys(coc_utms).length) return;

  $('.product-selector_block').each(function () {
    const coc_el = $(this);
    const coc_champsUrl = coc_el.attr('data-champs-url');
    if (!coc_champsUrl) return;

    const coc_parts = coc_champsUrl.split('?');
    const coc_baseUrl = coc_parts[0];
    const coc_champsParams = new URLSearchParams(coc_parts[1] || '');

    Object.keys(coc_utms).forEach(function (coc_key) {
      // avoid duplicates
      if (!coc_champsParams.has(coc_key)) {
        coc_champsParams.append(coc_key, coc_utms[coc_key]);
      }
    });

    coc_el.attr('data-champs-url', coc_baseUrl + '?' + coc_champsParams.toString());
  });

});
